import { value } from "lodash/seq";

const autodeskInventorLogo = require("../../media/inventor-logo.png");
const iconBook = require("../../media/icons/svg/Icon_Book.svg");
const iconNewAccount = require("../../media/icons/svg/Icon_NewAccount.svg");
const iconLogOut = require("../../media/icons/svg/Icon_LogOut.svg");
const iconHelp = require("../../media/icons/svg/Icon_Help.svg");
const iconPrintSystem = require("../../media/icons/svg/Icon_PrintSystem.svg");
const iconEmailBoards = require("../../media/icons/svg/Icon_EmailBoards.svg");
const iconManageProjects = require("../../media/icons/svg/Icon_ManageProjects.svg");
const iconSaveProject = require("../../media/icons/svg/Icon_SaveProject.svg");
const iconChevron = require("../../media/icons/svg/Icon_Chevron.svg");
const iconContact = require("../../media/icons/svg/Icon_Contact.svg");
const iconContactEmail = require("../../media/icons/svg/Icon_ContactEmail.svg");
const iconContactPhone = require("../../media/icons/svg/Icon_ContactPhone.svg");
const iconCreateNewProject = require("../../media/icons/svg/Icon_CreateNewProject.svg");
const iconDemo = require("../../media/icons/svg/Icon_Demo.svg");
const iconGlobeCountry = require("../../media/icons/svg/Icon_Globe-Country.svg");
const iconImperial = require("../../media/icons/svg/Icon_Imperial.svg");
const iconInfo = require("../../media/icons/svg/Icon_Info.svg");
const iconLanguage = require("../../media/icons/svg/Icon_Language.svg");
const iconPanningTool = require("../../media/icons/svg/Icon_PanningTool.svg");
const iconSaveAsDefaults = require("../../media/icons/svg/Icon_SaveAsDefaults.svg");
const iconZoomIn = require("../../media/icons/svg/Icon_ZoomIn.svg");
const iconZoomOut = require("../../media/icons/svg/Icon_ZoomOut.svg");
const iconZoomReset = require("../../media/icons/svg/Icon_ZoomReset.svg");
const iconUICheckboxFill = require("../../media/icons/svg/UI_CheckboxFill.svg");
const iconUICheckboxOutline = require("../../media/icons/svg/UI_CheckboxOutline.svg");

const IconsService = {
    ICONS: {
        autodeskInventorLogo: "autodeskInventorLogo",
        iconLogOut: "iconLogOut",
        iconNewAccount: "iconNewAccount",
        iconHelp: "iconHelp",
        iconEmailBoards: "iconEmailBoards",
        iconPrintSystem: "iconPrintSystem",
        iconManageProjects: "iconManageProjects",
        iconSaveProject: "iconSaveProject",
        iconBook: "iconBook",
        iconChevron: "iconChevron",
        iconContact: "iconContact",
        iconContactEmail: "iconContactEmail",
        iconContactPhone: "iconContactPhone",
        iconCreateNewProject: "iconCreateNewProject",
        iconDemo: "iconDemo",
        iconGlobeCountry: "iconGlobeCountry",
        iconImperial: "iconImperial",
        iconInfo: "iconInfo",
        iconLanguage: "iconLanguage",
        iconPanningTool: "iconPanningTool",
        iconSaveAsDefaults: "iconSaveAsDefaults",
        iconZoomIn: "iconZoomIn",
        iconZoomOut: "iconZoomOut",
        iconZoomReset: "iconZoomReset",
        iconUICheckboxFill: "iconUICheckboxFill",
        iconUICheckboxOutline: "iconUICheckboxOutline",
    },
    iconsArray: [
        {
            name: "autodeskInventorLogo",
            backgroundImage: `url(${autodeskInventorLogo})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconLogOut",
            backgroundImage: `url(${iconLogOut})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconNewAccount",
            backgroundImage: `url(${iconNewAccount})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconHelp",
            backgroundImage: `url(${iconHelp})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconEmailBoards",
            backgroundImage: `url(${iconEmailBoards})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconPrintSystem",
            backgroundImage: `url(${iconPrintSystem})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconManageProjects",
            backgroundImage: `url(${iconManageProjects})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconSaveProject",
            backgroundImage: `url(${iconSaveProject})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconBook",
            backgroundImage: `url(${iconBook})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconChevron",
            backgroundImage: `url(${iconChevron})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconContact",
            backgroundImage: `url(${iconContact})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconContact",
            backgroundImage: `url(${iconContact})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconContactEmail",
            backgroundImage: `url(${iconContactEmail})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconContactPhone",
            backgroundImage: `url(${iconContactPhone})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconCreateNewProject",
            backgroundImage: `url(${iconCreateNewProject})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconDemo",
            backgroundImage: `url(${iconDemo})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconGlobeCountry",
            backgroundImage: `url(${iconGlobeCountry})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconImperial",
            backgroundImage: `url(${iconImperial})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconInfo",
            backgroundImage: `url(${iconInfo})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconLanguage",
            backgroundImage: `url(${iconLanguage})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconPanningTool",
            backgroundImage: `url(${iconPanningTool})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconSaveAsDefaults",
            backgroundImage: `url(${iconSaveAsDefaults})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconZoomIn",
            backgroundImage: `url(${iconZoomIn})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconZoomOut",
            backgroundImage: `url(${iconZoomOut})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconZoomReset",
            backgroundImage: `url(${iconZoomReset})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconUICheckboxFill",
            backgroundImage: `url(${iconUICheckboxFill})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
        {
            name: "iconUICheckboxOutline",
            backgroundImage: `url(${iconUICheckboxOutline})`,
            backgroundSize: "30px 30px",
            width: "27px",
            height: "32px",
        },
    ],

    getIcon: ( name, backgroundSize = "36px 36px", width = "33px", height = "32px" ) => {
        try {
            const iconObj = JSON.parse(JSON.stringify(IconsService.iconsArray.find(icon => icon.name === name)));
            iconObj["backgroundSize"] = backgroundSize;
            iconObj["width"] = width;
            iconObj["height"] = height;
            return iconObj;
        } catch (error) {
            console.error("Error on IconsService.getIcon() :: ", error.message);
        }
    },
};

export default IconsService;



// WEBPACK FOOTER //
// ./src/lib/services/icons-service.js